import React, { FC } from 'react';
import styled from 'styled-components';
import {
  PickersLayout,
  StaticDatePicker,
  PickersActionBarProps,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Button } from '@mui/material';
import moment from 'moment';
import { PVNavy } from '@pv/common/colors';

interface DatePickerProps {
  date: Date | null;
  onChangeDate: (date: Date | null) => void;
  label?: string;
}

const StyledPickersLayout = styled(PickersLayout)({
  '& .MuiPickersToolbar-root': {
    backgroundColor: PVNavy,
    color: '#FFFFFF',

    '& .MuiTypography-root': {
      color: '#FFFFFF',
    },
  },
});

export const DatePicker: FC<DatePickerProps> = ({
  date,
  onChangeDate,
}: DatePickerProps) => {
  const CustomActionBar = (props: PickersActionBarProps) => {
    const { onClear, className } = props;

    return (
      <Button
        sx={{
          width: '90px',
          textTransform: 'none',
          color: PVNavy,
          borderRadius: '6px',
          border: '1px solid rgba(59, 57, 108, 0.15)',
          display: 'flex',
          justifyContent: 'center',
        }}
        className={className}
        onClick={() => {
          onChangeDate(null);
          onClear();
        }}
      >
        Any date
      </Button>
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <StaticDatePicker
        value={date ? moment(date) : null}
        onChange={(date) => onChangeDate(date ? date.toDate() : null)}
        slots={{
          layout: StyledPickersLayout,
          actionBar: CustomActionBar,
        }}
        slotProps={{
          actionBar: {
            actions: ['clear'],
          },
        }}
      />
    </LocalizationProvider>
  );
};
